import { IDeleteAvaliacaoHabilidadeUseCase } from "../../../presentation/useCases/delete/delete_avaliacao_habilidade_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteAvaliacaoHabilidadeUseCase
 */

export class DeleteAvaliacaoHabilidadeUseCase implements IDeleteAvaliacaoHabilidadeUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteAvaliacaoHabilidade(idAvaliacaoHabilidade: number): Promise<void> {
    await this.repository.deleteAvaliacaoHabilidade(idAvaliacaoHabilidade);
  }
}